<template>
<div class="login">
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-0">
          <v-card-text>
            <template v-if="store_slug !== ''">
              <router-link :to="'/' + store_slug + '/'" class="text-deco">
                <div class="pb-4">
                  <v-img width="160" src="/assets/icons/logo-hwi.png" class="mx-auto"></v-img>
                </div>
              </router-link>
            </template>
            <template v-else>
              <router-link to="/" class="text-deco">
                <div class="pb-4">
                  <v-img width="160" src="/assets/icons/logo-hwi.png" class="mx-auto"></v-img>
                </div>
              </router-link>
            </template>>

            <div class="pb-2 text-center text-subtitle-1 font-weight-bold black--text">
              Buat Akun HWI Ecommerce sekarang
            </div>
            <div class="text-subtitle-2 py-4">
              <span class="black--text">Sudah punya akun?</span>
              <router-link to="/login">
                <span class="font-weight-bold pl-2">Masuk di sini</span>
              </router-link>
            </div>

            <v-form ref="formRegister" role="form" v-on:submit.prevent="onRegister">
              <div class="pb-2">
                <div class="text-subtitle-2 primary--text pb-1">Username</div>
                <v-text-field small v-model="username" :rules="usernameRules" hide-details="auto" color="primary" validate-on-blur single-line outlined class="color-primary rounded-lg" height="40" dense @focus="() => fieldErrors.buyer_username=''" :error-messages="fieldErrors.buyer_username"></v-text-field>
              </div>
              <div class="pb-2">
                <div class="text-subtitle-2 primary--text pb-1">Nama Lengkap</div>
                <v-text-field small v-model="name" :rules="nameRules" hide-details="auto" color="primary" validate-on-blur single-line outlined class="color-primary rounded-lg" height="40" dense @focus="() => fieldErrors.buyer_name=''" :error-messages="fieldErrors.buyer_name"></v-text-field>
              </div>
              <div class="pb-2">
                <div class="text-subtitle-2 primary--text pb-1">Email</div>
                <v-text-field small v-model="email" :rules="emailRules" hide-details="auto" color="primary" validate-on-blur single-line outlined class="color-primary rounded-lg" height="40" dense @focus="() => fieldErrors.buyer_email=''" :error-messages="fieldErrors.buyer_email"></v-text-field>
              </div>
              <div class="pb-2">
                <div class="text-subtitle-2 primary--text pb-1">Nomor Handphone</div>
                <v-text-field small v-model="mobilephone" :rules="mobilephoneRules" hide-details="auto" @keypress="onlyNumber" @paste="validatePaste($event)" color="primary" validate-on-blur single-line outlined class="color-primary rounded-lg" height="40" dense @focus="() => fieldErrors.buyer_phone=''" :error-messages="fieldErrors.buyer_phone"></v-text-field>
              </div>

              <div class="pb-2 pt-4">
                <v-row>
                  <v-col md="12" cols="12" class="py-0">
                    <div class="text-subtitle-2 primary--text pb-1">Password</div>
                    <v-text-field small v-model="password" :rules="passwordRules" hide-details="auto" @click:append="showPassword" :type="passwordType" :append-icon="passwordIcon" color="primary" validate-on-blur single-line outlined class="color-primary rounded-lg" height="40" dense @focus="() => fieldErrors.buyer_password=''" :error-messages="fieldErrors.buyer_password"></v-text-field>
                  </v-col>
                  <v-col md="12" cols="12" class="py-2">
                    <div class="text-subtitle-2 primary--text pb-1">Ulangi Password</div>
                    <v-text-field small v-model="repassword" :rules="repasswordRules" hide-details="auto" @click:append="showrePassword" :type="repasswordType" :append-icon="repasswordIcon" color="primary" validate-on-blur single-line outlined class="color-primary rounded-lg" height="40" dense></v-text-field>
                  </v-col>
                </v-row>
              </div>

              <div class="pb-4">
                <div class="text-subtitle-2 primary--text pb-1">Provinsi</div>
                <v-autocomplete v-model="province" :preset-val="province" :rules="provinceRules" :items="provinces" item-text="province_name" color="primary" item-value="province_id" return-object single-line outlined class="rounded-lg text-body-1" height="45" dense hide-details="auto" no-data-text="Tidak ada data" @change="changeProvince(province.province_id)"></v-autocomplete>
              </div>
              <div class="pb-4" v-if="province">
                <div class="text-subtitle-2 primary--text pb-1">Kota/Kabupaten</div>
                <v-autocomplete v-model="city" :preset-val="city" :rules="cityRules" :items="cities" :item-text="item => item.type + ' ' + item.city_name" item-value="city_id" color="primary" return-object single-line outlined class="rounded-lg text-body-1" height="45" dense hide-details="auto" no-data-text="Tidak ada data" @change="changeCity(city.city_id)">
                  <template v-slot:item = {item}>
                    {{ item.type }} {{ item.city_name }}
                  </template>
                  <template v-slot:selection = {item}>
                    {{ item.type }} {{ item.city_name }}
                  </template>
                </v-autocomplete>
              </div>
              <div class="pb-4" v-if="city" id="coba">
                <div class="text-subtitle-2 primary--text pb-1">Kecamatan</div>
                <v-autocomplete v-model="district" :preset-val="district" :rules="districtRules" :items="districts" item-text="district_name" color="primary" item-value="district_id" return-object single-line outlined class="rounded-lg text-body-1" height="45" dense hide-details="auto" no-data-text="Tidak ada data" @change="changeDistrict(district.district_id)"></v-autocomplete>
              </div>
              <div class="pb-4" v-if="district" id="district">
                <div class="text-subtitle-2 primary--text pb-1">Desa</div>
                <v-autocomplete v-model="subdistrict" :preset-val="subdistrict" :rules="subdistrictRules" :items="subdistricts" color="primary" item-text="sub_district_name" item-value="sub_district_id" return-object single-line outlined class="rounded-lg text-body-1" height="45" dense hide-details="auto" no-data-text="Tidak ada data" @change="changeSubdistrict(subdistrict.postal_code)"></v-autocomplete>
              </div>
              <div class="pb-4" v-if="district">
                <div class="text-subtitle-2 primary--text pb-1">Alamat Lengkap</div>
                <v-textarea v-model="detail" :rules="detailRules" single-line outlined class="rounded-lg text-body-1" color="primary" placeholder="Isi nama jalan, nomor rumah, nama gedung, dsb" hide-details="auto" no-resize></v-textarea>
              </div>

              <div class="pt-4">
                <v-btn v-if="isAttempting" x-large depressed color="primary" class="col-12 rounded-lg">
                  <div class="subtitle-2">Sedang Diproses ...</div>
                </v-btn>
                <v-btn v-else x-large depressed color="primary" class="col-12 rounded-lg" type="submit">
                  <div class="subtitle-2">DAFTAR</div>
                </v-btn>

                <template v-if="store_slug !== ''">
                  <router-link :to="'/' + store_slug + '/'" class="d-block text-deco mt-3">
                    <v-btn text height="45" block color="primary" class="rounded-lg">
                      <div class="font-weight-bold text-body-2">Kembali ke Beranda</div>
                    </v-btn>
                  </router-link>
                </template>
                <template v-else>
                  <router-link :to="'/'" class="text-deco">
                    <v-btn text height="45" block color="primary" class="d-block rounded-lg mt-3">
                      <div class="font-weight-bold text-body-2">Kembali ke Beranda</div>
                    </v-btn>
                  </router-link>
                </template>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import {
  mapActions,
  mapState,
  mapMutations,
} from 'vuex'

// import authHelper from '@/helpers/auth'

function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export default {
  components: {},
  data() {
    return {
      store_slug: '',
      disabled_referal: false,
      responseData: 'The Best',
      alertColor: 'red',
      showme: false,
      password: '',
      repassword: '',
      name: '',
      username: '',
      email: '',
      mobilephone: '',
      referral: '',
      detail: '',
			province: null,
			city: null,
			district: null,
			subdistrict: null,
      passwordType: 'password',
      passwordIcon: 'mdi-eye',
      repasswordType: 'password',
      repasswordIcon: 'mdi-eye',
      aggreement: false,
      provinces: [],
			cities: [],
			districts: [],
			subdistricts: [],
      nameRules: [
        v => !!v || 'Nama tidak boleh kosong'
      ],
      usernameRules: [
        v => !!v || 'Username tidak boleh kosong'
      ],
      passwordRules: [
        v => !!v || 'Password tidak boleh kosong',
        v => v.length > 5 || 'Password minimal 6 karakter',
        v => v.length <= 20 || 'Password maksimal 20 karakter',
      ],
      repasswordRules: [
        v => !!v || 'Konfirmasi Password Anda',
        v => v === this.password || 'Konfirmasi Password tidak cocok',
      ],
      mobilephoneRules: [
        v => !!v || 'Nomor Handphone tidak boleh kosong',
        v => !isNaN(parseInt(v)) || 'Format Nomor Handphone tidak sesuai',
      ],
      referalRules: [
        v => !isNaN(parseInt(v)) || 'Format Nomor Handphone tidak sesuai',
      ],
      emailRules: [
        v => !!v || 'Email tidak boleh kosong',
        v => !!validateEmail(v) || 'Format Email tidak sesuai',
      ],
      agreeRules: [
        v => !!v || ''
      ],
      provinceRules: [
        v => !!v || 'Provinsi tidak boleh kosong',
      ],
      cityRules: [
        v => !!v || 'Kota tidak boleh kosong',
      ],
      districtRules: [
        v => !!v || 'Kecamatan tidak boleh kosong',
      ],
      subdistrictRules: [
        v => !!v || 'Desa tidak boleh kosong',
      ],
      detailRules: [
        v => !!v || 'Detail alamat tidak boleh kosong',
      ],
    }
  },
  computed: {
    ...mapState('auth', ['isAuth', 'isAttempting', 'alerts', 'fieldErrors']),
  },
  methods: {
    ...mapActions('auth', ['register', 'login']),
    ...mapMutations(['makeAlert']),

    async validatePaste(val, ref){
      let pasted = await val.clipboardData.getData('text')
      setTimeout(() => {
        if (!parseInt(pasted)) {
          if (ref === true) {
            this.referral = ''
          } else {
            this.mobilephone = ''
          }
        }
      })
    },
    showPassword() {
      if (this.passwordType == 'password') {
        this.passwordType = 'text'
        this.passwordIcon = 'mdi-eye-off'
      } else {
        this.passwordType = 'password'
        this.passwordIcon = 'mdi-eye'
      }
    },
    showrePassword() {
      if (this.repasswordType == 'password') {
        this.repasswordType = 'text'
        this.repasswordIcon = 'mdi-eye-off'
      } else {
        this.repasswordType = 'password'
        this.repasswordIcon = 'mdi-eye'
      }
    },
    async getProvince() {
			await this.$http
				.get(`area/get-province`)
				.then((res) => {
					const data = res.data.data
					this.provinces = data.results
				})
				.catch((error) => {
					console.log(error.response.data.message)
				})
		},

		async getCity(province_id) {
			await this.$http
				.get(`area/get-city?limit=0&province_id=${province_id}`)
				.then((res) => {
					const data = res.data.data
					this.cities = data.results
				})
				.catch((error) => {
					console.log(error.response.data.message)
				})
		},

		async getDistrict(city_id) {
			await this.$http
				.get(`area/get-district?limit=0&city_id=${city_id}`)
				.then((res) => {
					const data = res.data.data
					this.districts = data.results
				})
				.catch((error) => {
					console.log(error.response.data.message)
				})
		},

		async getSubdistrict(district_id) {
			await this.$http
				.get(`area/get-sub-district?limit=0&district_id=${district_id}`)
				.then((res) => {
					const data = res.data.data
					this.subdistricts = data.results
				})
				.catch((error) => {
					console.log(error.response.data.message)
				})
		},
    changeProvince(id) {
			this.city = null
			this.subdistrict = null
			this.getCity(id)
		},

		changeCity(id) {
			this.district = null
			this.getDistrict(id)
		},

		changeDistrict(id) {
			this.subdistrict = null
			this.zipcode = null
			this.getSubdistrict(id)
		},

		changeSubdistrict(code) {
			this.zipcode = code
		},
    onRegister() {
      if (this.$refs.formRegister.validate()) {
        let params = {
          buyer_username: this.username,
          buyer_name: this.name,
          buyer_email: this.email,
          buyer_phone: this.mobilephone,
          buyer_password: this.password,
          buyer_address_sub_district_id: this.subdistrict.sub_district_id,
          buyer_address_detail: this.detail
        }
        // console.log('params', params)
        this.register(params).then(() => {
          this.$router.push({
            name: "login"
          })
          this.makeAlert({ code: 'success', type: 'success', message: 'Proses Pendaftaran berhasil dilakukan', show: true })
        }).catch(() => {
          this.makeAlert({ code: 'error_response', type: 'error', message: 'Proses Pendaftaran gagal dilakukan', show: true })
        });
      }
    }
  },
  created() {
    this.$store.dispatch('setPageTitle', 'Daftar');
    let store = localStorage.getItem('HwiEcomStore')
    this.store_slug = ((store !== undefined)) ? store : ''

    this.getProvince()
  }
};
</script>
